import React from 'react'
import Section from '../components/Section.tsx'
import ProjectDescription from '../components/ProjectDescription.tsx'

export default function MyProfilePage() {
  return (
    <>
    <Section isLight={true} paddingBottom={0}>
      <>
        <ProjectDescription />
      </>
    </Section>
    

  </>  )
}
